export enum FileErrorType {
    INVALID_FILE_TYPE,      // File Invalid Type
    FILE_SIZE_LIMIT,        // File Size Limit
    FILE_NAME_LIMIT,         // File Name Limit
    UPLOAD_FAILED           // Upload failed
}